<template>
  <div class="examine">
    <examineTopbar
      v-model="currentCourseIndex"
      :statusList="statusList"
      @currentContentIndex="currentContentIndex"
      @searchText="searchText"
    />
    <div class="examine-main">
      <examineContentItem
        v-for="(item, index) in statusList"
        :key="index"
        :isCurrentContentItem="currentCourseIndex == index"
        :currentStatus="statusList[currentCourseIndex].value"
        @updateStatus="updateStatus"
        :changeStatus="changeStatus"
        :searchContent="searchContent"
      />
    </div>
    <examineDetail
      v-show="detailShow"
      :detailShow.sync="detailShow"
      :examineDetail="examineDetail"
      @showDetail="showDetail"
    />
  </div>
</template>

<script>
import examineTopbar from "./components/examine-topbar/examine-topbar.vue";
import examineContentItem from "./components/examine-content-item/examine-content-item.vue";
import examineDetail from "./components/examine-detail/examine-detail.vue";

export default {
  data() {
    return {
      currentCourseIndex: 0,
      changeStatus: 0,
      searchContent: "",
      statusList: [
        {
          label: "待审批",
          value: 0,
        },
        {
          label: "审批通过",
          value: 1,
        },
        {
          label: "审批拒绝",
          value: 2,
        },
      ],
      examineDetail: {},
      detailShow: false,
    };
  },
  components: {
    examineTopbar,
    examineContentItem,
    examineDetail,
  },
  created() {
    // 显示请假详情
    this.$eventBus.$off("showDetail");
    this.$eventBus.$on("showDetail", (id) => {
      this.selectExamineRecordDesc(id);
    });
    ``;
  },
  methods: {
    // 搜索词(接受topbar传来的值)
    searchText(e) {
      // console.log("父亲==>", e);
      // 搜索词改变时才赋值
      if (this.searchContent != e) {
        this.searchContent = e;
        // console.log("父亲==>",this.searchContent);
      }
    },
    updateStatus(e) {
      // console.log("updateStatus", e);
      this.changeStatus = e;
    },
    // 获取审批详情
    selectExamineRecordDesc(id) {
      this.post(this.$url.sensitivewordReviewId, {
        id,
      })
        .then((res) => {
          // console.log(res);
          this.examineDetail = res;
          this.detailShow = true;
        })
        .catch((err) => {
          this.$message.error("获取敏感字内容失败，请稍后再试");
        });
    },
    // 当前选中状态下标
    currentContentIndex(e) {
      this.currentCourseIndex = e;
    },
    showDetail(e){
      // console.log("状态切换",e);
      this.detailShow = e;
    }
  },
};
</script>

<style scoped lang="scss">
@import "./examine.scss";
</style>